import React, { Component } from "react";
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Button, 
  Glyphicon, 
  Modal, 
  Col,
  HelpBlock
 } from "react-bootstrap";
import LoaderButton from "../../components/LoaderButton";
import { invokeApig, s3Upload } from "../../libs/awsLib";
import "./NewGeofence.css";

export class NewGeofence extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: null,
      kmlName: "",
      kmlFile: null,
      show: false
    };
  }

  validateForm() {
    return (
      this.state.kmlFile && this.state.kmlFile.length
    );
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
      kmlFile: event.target.files[0]
    });
  }

  processKml(filename) {
    return invokeApig({
        path: "/zone",
        method: "POST",
        body: {
        	filename: filename
        }
      });
  }

  handleClose = () => {
    this.setState({ show: false });
  }

  showUploadFile = () => {
    this.setState({ show: true });
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    try {
      const result = await s3Upload(this.state.kmlFile);
      //llamar a API Gateway para procesar KML
      await this.processKml(result.key);
      this.handleClose();
    } catch (e) {
      alert(e);
    }
    this.setState({ isLoading: false });
  }

  renderFormNew(){
    return(
	  <Form horizontal onSubmit={this.handleSubmit}>
		<FormGroup controlId="kmlName">
	      <Col componentClass={ControlLabel} sm={3}>
	        Archivo KML{' '}
	      </Col>
	      <Col sm={9}>
	        <FormControl
	          onChange={this.handleChange}
	          type="file"
	          value={this.state.kmlName}
	          placeholder="Sube aquí tu KML."
	        />
	      </Col>
	      <HelpBlock>Selecciona tu archivo KML</HelpBlock>
	    </FormGroup>
        
        <LoaderButton
              block
              bsStyle="primary"
              bsSize="large"
              type="submit"
              isLoading={this.state.isLoading}
              text="Subir KML"
              loadingText="Guardando…"
            />
      </Form>
    );
  }

  render() {
    return (
      <div>
      	<Button onClick={this.showUploadFile} >
      	  <Glyphicon glyph="cloud-upload" />
      	</Button>
      	<Modal show={this.state.show} onHide={this.handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Subir KML</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.renderFormNew()}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleClose}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    </div>
    );
  }
}

export default NewGeofence


// WEBPACK FOOTER //
// ./src/containers/geofence/NewGeofence.js